import { type FunctionComponent } from "react";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";

import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";

import { useCftContentList } from "./hooks";
import {
  Container,
  ContentItemContainer,
  LoadMoreButton,
  StyledContentItemPlusCft,
  Wrapper,
} from "./styles";

type PlusCftContentListProps = {
  className?: string;
  selectedTopicIds: string[];
};

export const PlusCftContentList: FunctionComponent<PlusCftContentListProps> = ({
  className,
  selectedTopicIds,
}) => {
  const { handleOpen } = usePlusArticlePopup();
  const { contents, hasNext, isLoading, loadMore } = useCftContentList(selectedTopicIds);

  return (
    <BaseLinkContextProvider>
      <Wrapper className={className}>
        <Container>
          <ContentItemContainer>
            {contents.map((node, index) => (
              <StyledContentItemPlusCft
                key={index}
                onClick={() =>
                  handleOpen(node, {
                    pageType: "archive",
                  })
                }
                reference={node}
              />
            ))}
          </ContentItemContainer>
          {hasNext && (
            <LoadMoreButton disabled={isLoading} onClick={loadMore}>
              {isLoading ? "Loading..." : "Load more..."}
            </LoadMoreButton>
          )}
        </Container>
      </Wrapper>
    </BaseLinkContextProvider>
  );
};

PlusCftContentList.displayName = "PlusCftContentList";
